import { atom, useAtom } from "jotai";

export interface IndexPrices {
  BTC: number;
  ETH: number;
}

export const indexPricesAtom = atom<IndexPrices>({
  BTC: NaN,
  ETH: NaN,
});

export const useIndexPrices = () => {
  const [indexPrices, setIndexPrices] = useAtom(indexPricesAtom);

  return {
    indexPrices,
    setIndexPrices,
  };
};
